var rich_content_viewer_default = {
  "fontElementMap": "EoGiF",
  "wrapper": "rZMuz",
  "pluginContainerMobile": "On9PY",
  "viewer": "_2Zgip",
  "android": "CQ80X",
  "rootedTraversedContent": "zdPcs",
  "atomic": "U9UJ-",
  "toolbar": "JOERE",
  "block": "XzUAN"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
